import Vue from 'vue'
import VueRouter from 'vue-router'
import lockPage from './module/common/lockPage.vue'
require('bootstrap.min.css')
require('bootstrap.min.js')
require('./assets/style.css')
// require('daterangepicker.css')

var Rxports = {
    Vue,VueRouter,lockPage
};

module.exports = Rxports



// WEBPACK FOOTER //
// ./src/main.js